import React, { ReactNode } from 'react';
import { Drawer, Form, Button, FormInstance, DrawerProps } from 'antd';

interface FormDrawerProps extends DrawerProps {
  title: string;
  open: boolean;
  onClose: () => void;
  onSave: (values: any) => void;
  children: ReactNode;
  form: FormInstance;
  saveText?: string;
  width?: number;
  footer?: ReactNode | null;
}

const FormDrawer: React.FC<FormDrawerProps> = ({
  title,
  open,
  onClose,
  onSave,
  children,
  form,
  saveText = 'Save',
  width = 400,
  footer,
  ...rest
}) => {
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onSave(values);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const defaultFooter = (
    <div style={{ textAlign: 'right' }}>
      <Button onClick={onClose} style={{ marginRight: 8 }}>
        Cancel
      </Button>
      <Button type="primary" onClick={handleOk}>
        {saveText}
      </Button>
    </div>
  );

  return (
    <Drawer
      title={title}
      placement="right"
      width={width}
      onClose={onClose}
      open={open}
      footer={footer === null ? null : footer || defaultFooter}
      styles={{
        header: {
          color: 'white',
          backgroundColor: 'var(--color-primary)',
          fontWeight: 350,
          fontSize: '14px',
          border: 0,
          minHeight: '40px',
        },
      }}
      {...rest}
    >
      <Form form={form} layout="vertical">
        {children}
      </Form>
    </Drawer>
  );
};

export default FormDrawer;